module.exports = __webpack_public_path__ + "static/media/diagnonses_nok_icon.22d84c9f.svg";